import { render, staticRenderFns } from "./retailAddOrder.vue?vue&type=template&id=8fc0a634&scoped=true"
import script from "./retailAddOrder.vue?vue&type=script&lang=js"
export * from "./retailAddOrder.vue?vue&type=script&lang=js"
import style0 from "./retailAddOrder.vue?vue&type=style&index=0&id=8fc0a634&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc0a634",
  null
  
)

export default component.exports